import { useTranslation } from "react-i18next";
import { Typography } from "@material-ui/core";

const LabelSuccess = ({ text }) => {
  const { t } = useTranslation();

  return (
    <>
      <Typography style={{color: "#5cb85c", background: "#e2f2e2"}} align="center">
        {t(text)}
      </Typography>
    </>
  );
};

export default LabelSuccess;
